import { INavItemProps } from 'components/atoms/NavItem'
import { IUser } from 'static/interfaces'
import { NAV_ITEMS_AGENT, NAV_ITEMS_GUIDE } from 'static/sidebarMenu'

const checkIfActive = (menu_item: INavItemProps, path) => {
  let response = false
  // I use for loop because break does not work in forEach
  for (const menu of menu_item.activate_paths) {
    if (path.match(menu)) {
      response = true
      break
    }
  }
  return response
}

const getNavItemsFromRoleLabel = (roleLabel: string) => {
  switch (roleLabel) {
    case 'agent':
      return NAV_ITEMS_AGENT
    case 'guide':
      return NAV_ITEMS_GUIDE
    default:
      return []
  }
}

export const getRoleLabel = (user: IUser | null) => {
  if (user?.admin) {
    return 'admin'
  }
  if (user?.agent) {
    return 'agent'
  }
  if (user?.guide) {
    return 'guide'
  }
  if (user?.guest) {
    return 'guest'
  }
  return ''
}

export const isShowSidebarFromRoleLabel = (roleLabel: string) => {
  return roleLabel === 'guide' || roleLabel === 'agent'
}

export const getNavItemsWithActive = (roleLabel: string) => {
  const navItemsList = getNavItemsFromRoleLabel(roleLabel)

  const withActive = navItemsList.map(item => {
    return {
      ...item,
      active: checkIfActive(item, location.pathname),
      children: item.children?.map(child => ({
        ...child,
        active: checkIfActive(child, location.pathname),
      })),
    }
  })

  return withActive
}
